import './DivisorLine.scss';

const DivisorLine = () => {
    return <div className='divisor-line'></div>
};

export default DivisorLine;